import { render, staticRenderFns } from "./ImpulseController.vue?vue&type=template&id=5a575813&scoped=true&"
import script from "./ImpulseController.vue?vue&type=script&lang=js&"
export * from "./ImpulseController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a575813",
  null
  
)

export default component.exports